// bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoMenu from "./../services/bao-menu";
import BaseViewModel from "./base-view-model";
import AppTabController from "./../services/app-tab-controller";
import BaoDialogViewModel from "./bao-dialog";
class SearchPaging extends BaseViewModel {
    constructor(tabPage) {
        super(tabPage);
        var self: any = this;
        self.SearchId = ko.observable();
        self.BackwardVisible = ko.observable();
        self.ForwardVisible = ko.observable();
        self.CurrentTotalCount = ko.observable();
        self.CurrentSearchIndex = ko.observable();
        self.SearchPagingActive = ko.observable(true);
        self.DisplayNumbers = ko.observable(true);
        self.TabName = ko.observable();
        if (!self.PermissionForward)
            self.PermissionForward = "";
        if (!self.PermissionBackward)
            self.PermissionBackward = "";
        self.TabName.subscribe(function (value) {
            if (value != "") {
                if (self.SearchPagingActive() && self.CurrentSearchIndex() != null && self.BackwardVisible() == null && self.ForwardVisible() == null) {
                    tabPage.Title(value + " (" + (self.CurrentSearchIndex() + 1) + " / " + self.CurrentTotalCount() + ")");
                }
                else {
                    tabPage.Title(value);
                }
            }
        });
        self.CurrentSearchIndex.subscribe(function () {
            self.SearchIndexChanged(self.PermissionForward, self.PermissionBackward);
        });
        self.ForwardVisible.subscribe(function () {
            self.SearchIndexChanged(self.PermissionForward, self.PermissionBackward);
        });
        self.BackwardVisible.subscribe(function () {
            self.SearchIndexChanged(self.PermissionForward, self.PermissionBackward);
        });
        self.TempNewIndex = null;
        self.SearchedEvent = $.proxy(self.SearchedEvent, self);
        Bao.bindEvent("searched", self.SearchedEvent);
        self.SearchPagingActive.subscribe(function (item) {
            if (item == true) {
                self.CurrentSearchIndex.valueHasMutated();
            }
        });
        self.Destroy.push(function () {
            Bao.unbindEvent("searched", self.SearchedEvent);
        });
        tabPage.MenuEvents.push(BaoMenu.registerEvent(function (value) {
            if (tabPage.IsActiveTab() === true) {
                switch (value.ActionKey()) {
                    case self.PermissionForward:
                        self.MoveSearch(self.CurrentSearchIndex() + 1, "forward");
                        break;
                    case self.PermissionBackward:
                        self.MoveSearch(self.CurrentSearchIndex() - 1, "backward");
                        break;
                }
            }
        }));
    }
    SearchIndexChanged = function () {
        var backVisible = this.CurrentSearchIndex() > 0 && this.BackwardVisible() == null || this.BackwardVisible();
        var forwardVisible = this.CurrentSearchIndex() + 1 < this.CurrentTotalCount() && this.ForwardVisible() == null || this.ForwardVisible();
        BaoMenu.permissionEnable({
            ActionKey: this.PermissionBackward,
            Enabled: backVisible,
            Context: this.TabPage.Context()
        });
        BaoMenu.permissionEnable({
            ActionKey: this.PermissionForward,
            Enabled: forwardVisible,
            Context: this.TabPage.Context()
        });
        BaoMenu.permissionVisible({
            ActionKey: this.PermissionBackward,
            Visible: true,
            Context: this.TabPage.Context()
        });
        BaoMenu.permissionVisible({
            ActionKey: this.PermissionForward,
            Visible: true,
            Context: this.TabPage.Context()
        });
        this.TabPage.DirtyFlag.pause();
        this.TabName.valueHasMutated();
        this.TabPage.DirtyFlag.resume();
    };
    SearchedEvent = function () {
        BaoMenu.permissionVisible({
            ActionKey: this.PermissionForward,
            Visible: false,
            Context: this.TabPage.Context()
        });
        BaoMenu.permissionVisible({
            ActionKey: this.PermissionBackward,
            Visible: false,
            Context: this.TabPage.Context()
        });
        this.SearchPagingActive(false);
        this.TabPage.DirtyFlag.pause();
        this.TabName.valueHasMutated();
        this.TabPage.DirtyFlag.resume();
        Bao.unbindEvent("searched", this.SearchedEvent);
    };
    MoveSearch = function (newIndex, mode) {
        var self = this;
        if (newIndex >= 0 && newIndex < self.CurrentTotalCount() || mode == "forward" && self.ForwardVisible() || mode == "backward" && self.BackwardVisible()) {
            if (self.TabPage.DirtyFlag() && (self.SaveAllowed == null || self.SaveAllowed())) {
                self.TabPage.IsLoading(false);
                var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgSaveCheck"), "question");
                questionDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.DeferredCompleteCheck().then(function (result) {
                            if (result == true) {
                                $.when(self.Save()).then(function () {
                                    self.PerformMoveSearch(newIndex, mode);
                                });
                            }
                        });
                    }
                    else if (result === false) {
                        self.PerformMoveSearch(newIndex, mode);
                    }
                });
            }
            else {
                self.PerformMoveSearch(newIndex, mode);
            }
        }
        else { }
    };
    PerformMoveSearch = function (newIndex, mode) {
        var self = this;
        self.TempNewIndex = newIndex;
        self.TabPage.IsLoading(true);
        var searchTab = AppTabController.SearchTabByObjectId("Search");
        if (searchTab != null) {
            searchTab.ViewModel().GetSearchItem(newIndex, self, mode).then(function (searchItem) {
                if (self.TabPage.IsActiveTab() == true) {
                    var tabFound = AppTabController.SearchTabByObjectId(searchItem.PrimaryKeyValue);
                    if (tabFound != null) {
                        setTimeout(function () {
                            tabFound.ViewModel().CurrentTotalCount(self.CurrentTotalCount());
                            tabFound.ViewModel().CurrentSearchIndex(self.TempNewIndex);
                            tabFound.ViewModel().SearchPagingActive(true);
                            AppTabController.SelectTab(tabFound);
                            self.TabPage.IsLoading(false);
                        }, 0);
                    }
                    else {
                        self.SetSearchMovedItem(searchItem);
                    }
                }
            });
        }
    };
    SetSearchMovedItem = function (searchItem) {
        this.TabPage.DirtyFlag.reset();
        this.TabPage.DirtyFlag.pause();
        this.CurrentSearchIndex(this.TempNewIndex);
        this.TabPage.DirtyFlag.pause();
        if (this.PrimaryKey != null && this[this.PrimaryKey] != null && searchItem != null && searchItem[this.PrimaryKey] != null) {
            var pk = searchItem[this.PrimaryKey];
            this[this.PrimaryKey](pk);
            this.TabPage.ObjectId(pk);
            this.PrimaryKeyValue(pk);
            this.OpenData(pk);
        }
        this.PerformRefresh();
        this.TabPage.DirtyFlag.resume();
    };
    InitPaging = function () {
        var searchObject;
        if (this.TabPage.Object != null && this.TabPage.Object.searchObject != null) {
            searchObject = this.TabPage.Object.searchObject;
        }
        else if (Bao != null && Bao.Search != null && Bao.Search.CurrentSearchObject != null && Bao.Search.CurrentSearchObject.id != null && this.PrimaryKey != null && ko.unwrap(this[this.PrimaryKey]) == Bao.Search.CurrentSearchObject.id) {
            searchObject = Bao.Search.CurrentSearchObject;
        }
        if (searchObject != null) {
            this.CurrentTotalCount(searchObject.totalCount);
            this.CurrentSearchIndex(searchObject.rowIndex);
            this.SearchId(searchObject.id);
            if (searchObject.forwardVisible != null) {
                this.ForwardVisible(searchObject.forwardVisible);
            }
            if (searchObject.backwardVisible != null) {
                this.BackwardVisible(searchObject.backwardVisible);
            }
        }
        else {
            BaoMenu.permissionVisible({
                ActionKey: this.PermissionForward,
                Visible: false,
                Context: this.TabPage.Context()
            });
            BaoMenu.permissionVisible({
                ActionKey: this.PermissionBackward,
                Visible: false,
                Context: this.TabPage.Context()
            });
            this.SearchPagingActive(false);
        }
    }
    loaded = function () {
        this.InitPaging();
        this.TabPage.DirtyFlag.reset();
        this.TabPage.IsLoading(false);
        this.Focus();
    }
}
export default SearchPaging;

